import { Button } from "@mui/material";
import { GROUP_LIST_OBJECT } from "../../../../constants/groupList/GroupList";
import useRouteParam from "../../../../hooks/useRouteParam";
import ReportBox from "../../../shared/reportBox/ReportBox";
import Topbar from "../../../shared/topbar/Topbar";
import ReplyIcon from "@mui/icons-material/Reply";
import SendIcon from "@mui/icons-material/Send";
import { useNavigate } from "react-router-dom";
import { api } from "../../../../utils/api";
import convertJSONToCSV from "../../../../utils/commonFunctions/jsonToCsv";
import { useState } from "react";
import LoadingIndicator from "../../../../utils/promiseTracker/LoadingIndicator";
import {
	appealsFieldListChecked,
	appealsFieldListSelected,
	appealsFieldListUnChecked,
	idrTrackersFieldListChecked,
	idrTrackersFieldListSelected,
	idrTrackersFieldListUnChecked,
	paidClaimsFieldListChecked,
	paidClaimsFieldListSelected,
	paidClaimsFieldListUnChecked
} from "../../../../constants/fieldsList/FieldsList";
import { DateFilter } from "../../../../@types/dateFilter.types";
import { appealsIDRTrackersCommonUnionProps, FilterState } from "../../../../@types/appealReportAllprops.types";

const AppealReport = () => {
	const groupNumber = useRouteParam("gn");
	const group = GROUP_LIST_OBJECT.get(Number(groupNumber) || 220);
	const navigate = useNavigate();
	const [loading, setLoading] = useState<boolean>(false);

	// Selected columns state
	const initialSelectedColumns = {
		paidclaims: paidClaimsFieldListChecked,
		idrtrackers: idrTrackersFieldListUnChecked,
		appeals: appealsFieldListUnChecked
	};
	// Selected columns state for filter
	const initialFIlterColumns = {
		paidclaims: paidClaimsFieldListUnChecked,
		idrtrackers: idrTrackersFieldListUnChecked,
		appeals: appealsFieldListUnChecked
	};

	const [selectedColumns, setSelectedColumns] =
		useState<Record<string, Record<string, boolean>>>(initialSelectedColumns);
	const [filteredColumns, setFilteredColumns] =
		useState<Record<string, Record<string, boolean>>>(initialFIlterColumns);

	const [filters, setFilters] = useState<FilterState>({
		paidclaims: {},
		appeals: {},
		idrtrackers: {}
	});

	const [appealsIDRTrackersCommonUnion, setAppealsIDRTrackersCommonUnion] =
		useState<appealsIDRTrackersCommonUnionProps>({
			appeals: null,
			idrtrackers: null
		});

	const handleAppealsIDRTrackersCommonUnionChange = (claimType: string, value: "union" | "common" | null) => {
		console.log(value, claimType, appealsIDRTrackersCommonUnion);
		setAppealsIDRTrackersCommonUnion({ ...appealsIDRTrackersCommonUnion, [claimType]: value });
	};
	const handleUpdateSelectedColumns = (key: string, checked: boolean, claimType: string) => {
		setSelectedColumns((prevState: Record<string, Record<string, boolean>>) => {
			// Update the specific key's value in the claimType object
			const updatedColumns = {
				...prevState[claimType], // Copy existing columns for the given claimType
				[key]: checked // Set the updated value for the specific key
			};

			return { ...prevState, [claimType]: updatedColumns }; // Return the updated state
		});
	};
	const handleUpdateFiltersSelection = (key: string, checked: boolean, claimType: string) => {
		// Update the filteredColumns state to reflect the checkbox change
		setFilteredColumns((prevState: Record<string, Record<string, boolean>>) => {
			const updatedColumns = {
				...prevState[claimType],
				[key]: checked // Set the updated value for the specific key
			};
			return { ...prevState, [claimType]: updatedColumns };
		});

		// If the field is unchecked, remove the filter for that field from the filters state
		if (!checked) {
			setFilters((prevFilters: FilterState) => {
				const updatedFilters = { ...prevFilters };
				// Remove the filter for the specific field and claimType
				delete updatedFilters[claimType as keyof FilterState][key];
				return updatedFilters;
			});
		}
	};

	const handleFilterChange = (
		component: keyof FilterState,
		field: string,
		value: string | number | Date | DateFilter | boolean
	) => {
		setFilters((prevFilters: FilterState) => ({
			...prevFilters,
			[component]: {
				...prevFilters[component],
				[field]: value
			}
		}));
	};

	const routeBack = () => {
		navigate("/idr/dashboard");
	};

	const handleGenerateReport = async () => {
		const filter = {
			group_no: group.number,
			selectedColumns: selectedColumns,
			filters: filters,
			appealsIDRTrackersCommonUnion: appealsIDRTrackersCommonUnion
		};

		console.log(filter);
		try {
			setLoading(true);
			const reportList = await api.paidClaim.getAppealPaidClaims(filter);
			convertJSONToCSV(reportList, "Appeal Related Claims");
			alert("Report Generated Successfully !!");
		} catch (error) {
			console.error(error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div className="landing">
			<Topbar />
			{groupNumber && (
				<div className="logo" style={{ marginTop: 60 }}>
					<img src={group.logo} alt="Group Logo" />
				</div>
			)}
			<div
				style={{
					marginTop: "4rem",
					width: "100%",
					display: "flex",
					justifyContent: "space-between"
				}}
			>
				<Button variant="contained" className="button-blue-light-v2" onClick={routeBack}>
					<ReplyIcon style={{ marginRight: "4px" }} />
					Return to Dashboard
				</Button>

				<Button
					variant="contained"
					className="button-red"
					endIcon={<SendIcon />}
					onClick={handleGenerateReport}
				>
					Generate
				</Button>
			</div>
			<ReportBox
				group_name={group.name}
				selectedColumns={selectedColumns}
				filteredColumns={filteredColumns}
				filters={filters}
				handleUpdateSelectedColumns={handleUpdateSelectedColumns}
				handleUpdateFiltersSelection={handleUpdateFiltersSelection}
				handleFilterChange={handleFilterChange}
				appealsIDRTrackersCommonUnion={appealsIDRTrackersCommonUnion}
				handleAppealsIDRTrackersCommonUnionChange={handleAppealsIDRTrackersCommonUnionChange}
				// setSelectedColumns={setSelectedColumns}
				// setFilteredColumns={setFilteredColumns}
			/>
			{loading && <LoadingIndicator />}
		</div>
	);
};

export default AppealReport;
